import { getBaseRole } from '@/helpers/customRoles';
// самостоятельно возвращает id пользователя если роль не родитель, а если родитель, 
// то возвращает id выбранного ученика для просмотра

import { useSelector } from 'react-redux';
import { selectProfile } from '@store/profile.reducer';

export const useGetId = () => {
    const { id: myId, role } = useSelector(selectProfile);
	const parentSelectedChildId = useSelector((state) => state.parentSelectedChildId);
    let id = myId;

	if(getBaseRole(role) === 'parent'){
		id = parentSelectedChildId;
	} 

    return id;
};
